var exports = {
  "j": "attachmentText__WlECjH",
  "h": "attachmentPreviewImage__4tQw1p",
};

module.exports = exports;
